module.exports = __webpack_public_path__ + "img/a5.f3c9f324.png";